var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConsumerDiscretionary = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    viewBox: "0 0 32 33",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.903,
    height: 32,
    y: 0.378,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    fillRule: "evenodd",
    d: "M8.797 17.57c-.173.12-.226.323-.226.855v.489h9.462v-.53c0-.315-.022-.575-.053-.645-.115-.252.082-.242-4.689-.242-3.988 0-4.4.007-4.494.072m-.37 2.462c-.229.28-.468.67-.63 1.028-.594 1.302-.99 3.428-1.07 5.716l-.027.8.136.152.136.152 6.283.012c6.94.012 6.464.032 6.619-.267.067-.13.069-.229.02-1.11-.173-3.18-.768-5.435-1.716-6.51l-.143-.161H8.581z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    fillRule: "evenodd",
    d: "M14.495 7.121c-1.287.13-2.313.418-3.357.943a8.9 8.9 0 0 0-2.32 1.652c-.475.463-.55.586-.492.818.042.174 2.785 2.924 2.964 2.972.243.065.376-.017.96-.602l.565-.564v4.224l2.554.013c2.501.012 2.557.014 2.758.107.293.136.548.384.69.673.12.247.122.265.136 1.196l.015.945.203.295c.29.422.684 1.27.88 1.9l.17.541h1.32c1.136 0 1.336-.01 1.44-.07.262-.155.246.155.259-5.042l.012-4.78.563.563c.585.584.717.666.96.601.18-.048 2.922-2.798 2.965-2.972.056-.23-.018-.356-.481-.809a9.13 9.13 0 0 0-5.547-2.588c-.678-.067-.817.016-.93.556a2.84 2.84 0 0 1-2.154 2.165 2.82 2.82 0 0 1-3.344-2.165 1.8 1.8 0 0 0-.112-.35c-.065-.128-.3-.257-.443-.244-.043.003-.148.014-.234.022",
    clipRule: "evenodd"
  })));
};
export default SvgConsumerDiscretionary;